import {
  component_styles_default,
  r
} from "./chunk.3PRAXUFA.js";

// node_modules/@shoelace-style/shoelace/dist/chunks/chunk.NPYVPRSA.js
var icon_styles_default = r` ${component_styles_default} :host { display: inline-block; width: 1em; height: 1em; contain: strict; box-sizing: content-box !important; } .icon, svg { display: block; height: 100%; width: 100%; } `;

export {
  icon_styles_default
};
